import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {HttpVersionInterceptor} from "../services/http-version.interceptor";


const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: '/login'
    },
    {
        path: 'registo',
        loadChildren: () => import('./registo/registo.module').then(m => m.RegistoModule)
    },
    {
        path: 'playground',
        loadChildren: () => import('./playground/playground.module').then(m => m.PlaygroundModule)
    },
    {
        path: 'login',
        loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
    },
    {
        path: 'candidatura',
        loadChildren: () => import('./candidatura/candidatura.module').then(m => m.CandidaturaModule)
    },
    { path: 'gestao', loadChildren: () => import('./gestao/gestao.module').then(m => m.GestaoModule) }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {useHash: true})],
    exports: [RouterModule],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpVersionInterceptor,
            multi: true
        }
    ]
})
export class AppRoutingModule {
}
